var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods1"},[_c('div',{staticClass:"mb20"},[_vm._v("\n    请前往菜单，内容营销＞通用设置，客服一栏进行相关配置。\n  ")]),_vm._v(" "),_c('div',{staticClass:"mb20"},[_vm._v("\n    需要配置微信客服二维码、客服联系邮箱、客服工作时间、客服联系电话。\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e679520","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/designPage/template/footer/footer1/setting.vue
// module id = null
// module chunks = 